"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxToggleAdapter = exports.CheckboxToggle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CheckboxToggle = require("../../microFields/CheckboxToggle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * CheckboxToggle input type=checkbox
 * therefore this component assumes input.value is boolean
 * This field should always have initialValues set in the form
 */
var CheckboxToggle = function CheckboxToggle(_ref) {
  var input = _ref.input,
      label = _ref.label,
      styleType = _ref.styleType,
      cashbotName = _ref.cashbotName,
      openLinksInNewTab = _ref.openLinksInNewTab,
      meta = _ref.meta,
      isRequiredField = _ref.isRequiredField;
  return _react.default.createElement(_CheckboxToggle.CheckboxToggle, _extends({}, input, {
    name: input.name,
    value: input.value,
    onChange: input.onChange,
    onFocus: input.onFocus,
    onBlur: input.onBlur,
    label: label,
    cashbotName: cashbotName,
    styleType: styleType,
    isInvalid: meta.invalid,
    isTouched: meta.touched,
    warningMessage: meta.warning,
    errorMessage: meta.error,
    openLinksInNewTab: openLinksInNewTab,
    isRequiredField: isRequiredField
  }));
};

exports.CheckboxToggle = CheckboxToggle;
CheckboxToggle.defaultProps = {
  styleType: 'toggle',
  openLinksInNewTab: false,
  meta: {},
  isRequiredField: false
};
CheckboxToggle.propTypes = {
  input: _propTypes.default.object.isRequired,
  meta: _propTypes.default.object,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  styleType: _propTypes.default.oneOf(['toggle', 'checkbox']),
  openLinksInNewTab: _propTypes.default.bool,
  isRequiredField: _propTypes.default.bool
};
var CheckboxToggleAdapter = CheckboxToggle;
exports.CheckboxToggleAdapter = CheckboxToggleAdapter;